export default __webpack_public_path__ + "static/media/icon_lipids.69e42d9a.svg";